import rawConfig from "../config.json";


interface IConfig {
    general: any
}

// export type {ITimeseriesLabels, ITimeseriesParams, ITimeseriesOrder};

export const config: IConfig = {
    general: rawConfig.general
};

